import { Button, Modal, Spin, Table, Tabs, TabsProps, Timeline } from 'antd'
import moment from 'moment'
import React,{useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EyeOutlined } from '@ant-design/icons';
import { formatNumberWithCommas, rejectedApiMessage } from '../../utilities/CommonHelper';
import { setoboModalDetails } from '../../store/reducers/reportsSlice';

const OboDetailsModal = (props:any) => {
  const dispatch = useDispatch();
  const reportsData = useSelector((state: any) => state.reports);
  const [sowLevelList, setSowLevelList] = React.useState([]);
  const [workorderLevelList, setWorkorderLevelList] = React.useState([]);
  const [activeTabKey, setActiveTabKey] = React.useState('1');

  useEffect(() => {
      if(reportsData?.oboModal.isModalOpen){
        if(reportsData.oboModal.activeTab==="sowTab"){
          setSowLevelList(reportsData?.oboModal.selectedOpp.oboSowDto);
          setActiveTabKey("1");
          setWorkorderLevelList([]);
        }
        else{
          setWorkorderLevelList(reportsData?.oboModal.selectedSOW.oboWoDto);
          setActiveTabKey("2");
        }
      }else{
        setSowLevelList([]);
        setWorkorderLevelList([]);
        setActiveTabKey("1");

      }
  }, [reportsData?.oboModal.isModalOpen,reportsData.oboModal.activeTab])

  const onTabChange = (key: string) => {
    setActiveTabKey(key);
    if(key==='1'){
      setSowLevelList(reportsData?.oboModal.selectedOpp.oboSowDto ||[])
      setWorkorderLevelList([])
      dispatch(setoboModalDetails({
        isModalOpen:true,
        selectedSOW:{},
        selectedOpp:reportsData?.oboModal.selectedOpp,
        activeTab: "sowTab"
      }))
    }
    else{

      setWorkorderLevelList(reportsData?.oboModal.selectedSOW.oboWoDto || [] )
      dispatch(setoboModalDetails({
        isModalOpen:true,
        selectedSOW:reportsData?.oboModal.selectedSOW,
        selectedOpp:reportsData?.oboModal.selectedOpp,
        activeTab: "workorderTab"
      }))
    }
    
  }

  const  handleViewWO = (record:any) => {
    setActiveTabKey("2");
    setWorkorderLevelList(record.oboWoDto);
    dispatch(setoboModalDetails({
      isModalOpen:true,
      selectedSOW:record,
      selectedOpp:reportsData?.oboModal.selectedOpp,
      activeTab:"workorderTab"
    }))
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'SOW Level',
      children: 
                <>
                  <div>

                    <p>
                      <b>Opportunity Id:</b> {reportsData?.oboModal.selectedOpp.opportunityID}
                    </p>
                    {/* <p>
                      <b>User Email:</b> {selectedemployeeData?.email}
                    </p> */}
                    </div>
                    <Table
                    dataSource={sowLevelList}
                    scroll={{ x: 'max-content',y: 300}}
                    className='table-style'
                    columns={[
                      {
                        title: 'SOW ID',
                        dataIndex: 'sowid',
                        key: 'sowid',
                        width: 150,
                      },
                      {
                        title: 'SOW Start Date',
                        dataIndex: 'sowStartDate',
                        key: 'sowStartDate',
                        width: 150,
                      },
                      {
                        title: 'SOW End Date',
                        dataIndex: 'sowEndDate',
                        key: 'sowEndDate',
                        width: 150,
                      },
                      {
                        title: 'SOW Contract Value',
                        dataIndex: 'sumOfTCV',
                        key: 'sumOfTCV',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'Revenue Recognised',
                        dataIndex: 'revenue',
                        key: 'revenue',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'OBO Value',
                        dataIndex: 'obo',
                        key: 'obo',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title:'Work Orders',
                        key:'action',
                        dataIndex:'action',
                        fixed: 'right',
                        width: 50,
                        render: (text: string, record: any) => {
                          return(
                            <Button type='link' style={{background:'none', border:'none'}} onClick={()=>handleViewWO(record)}><EyeOutlined /></Button>
                          )
                        }
                      }

                    ]}
                    // loading={userDashboard?.loading}
                    />
                </>,
    },
    {
      key: '2',
      label: 'Work Order Level',
      disabled: true,
      children: <>
                  <div>

                    <p>
                      <b>SOW Id:</b> {reportsData?.oboModal.selectedSOW?.sowid}
                    </p>
                    </div>
                    <Table
                    dataSource={workorderLevelList}
                    scroll={{ x: 'max-content',y: 300}}
                    className='table-style'
                    columns={[
                      {
                        title: 'Work Order ID',
                        dataIndex: 'woId',
                        key: 'woId',
                        width: 150,
                      },
                      {
                        title: 'Parent Id',
                        dataIndex: 'parentId',
                        key: 'parentId',
                        width: 150,
                      },
                      {
                        title: 'Total Contract Value',
                        dataIndex: 'sumOfTCV',
                        key: 'sumOfTCV',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'Revenue Recognised',
                        dataIndex: 'revenue',
                        key: 'revenue',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'OBO Value',
                        dataIndex: 'obo',
                        key: 'obo',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      }

                    ]}
                    // loading={userDashboard?.loading}
                    />
                </>,
    },
  ]
  return (
    <Modal
    // title={reportsData?.oboModal.activeTab==="sowTab"?"SOW's OBO Details":"Work Orders OBO Details"}
    open={props.visible}
    onCancel={()=>props.onCancel()}
    footer={null}
    width={1000}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <Spin spinning ={reportsData?.loading }>

    <Tabs defaultActiveKey="1" activeKey={activeTabKey} items={ items}
          onChange={onTabChange} />


      
    </Spin>
  </Modal>
  )
}
export default OboDetailsModal;
